import * as actionTypes from "../constants/action-types";

/** EXAMPLE ACTIONS

 ***ASYNC EXAMPLE:

 export const doSomeAction = (foo): (any => void) => {
    function thunk(dispatch) {
        someAsyncFunction(foo)
            .then((result: mixed) => {
                dispatch({ type: actionTypes.SOME_ACTION_SUCCESS, payload: {result}});
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.SOME_ACTION_FAIL, payload: {error} });
            });
    }
    thunk.interceptOnOffline = true;
    return thunk;
};


 ***SYNCHRONOUS EXAMPLE:

 export const soSomeAction = (api: DataType): ActionType => (
 {
        type: actionTypes.SOME_ACTION,
        api
    }
 );

 **/


/**
 *  opens the Modal
 *  @param {string} modalId - id of modal to open
 * @returns {Object} - action
 */
export const openModal = modalId => ({
    type: actionTypes.OPEN_MODAL,
    payload: { data:  modalId }
});


/**
 * closes the Modal
 * @param {string} modalId - id of modal to close
 * @returns {Object} - action
 */
export const closeModal = modalId => ({
    type: actionTypes.CLOSE_MODAL,
    payload: { data:   modalId }
});


/**
 * toggles the Modal
 * @param {string} modalId - id of modal to toggle
 * @returns {Object} - action
 */
export const toggleModal = modalId => ({
    type: actionTypes.TOGGLE_MODAL,
    payload: { data: { modalId } }
});


/**
 * closes all Modals
 * @returns {Object} - action
 */
export const closeAllModals = () => ({
    type: actionTypes.CLOSE_ALL_MODALS
});

/**
 * opens one modal exclusively
 * @param {string} modalId - id of modal to toggle
 * @returns {Object} - action
 */
export const openModalExclusively = modalId => ({
    type: actionTypes.OPEN_MODAL_EXCLUSIVE,
    payload: { data: { modalId } }
});
